export const USER_LOGIN_REQUEST = 'USER_LOGING_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGING_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGING_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_SIGNUP_REQUEST = 'USER_SIGNUP_REQUEST';
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_SIGNUP_FAIL = 'USER_SIGNUP_FAIL';
